import { INotification, NotificationType } from 'src/api/getNotifications/getNotifications';

/**
 * The service-ingest pipeline is opt-in per integration, so both sync flows are live at the same
 * time and the UI has to tell a given sync apart. `assets` is the discriminator the API gives us:
 * legacy syncs leave it null, ingest syncs list the payload they wrote to S3.
 */
export const isIngestSyncNotification = (notification?: INotification): boolean => !!notification?.assets?.length;

/**
 * The PRODUCT_SYNC notification for one event. `/items/sync/status` carries no equivalent of
 * `assets`, so the notification is currently the only place the pipeline can be read from.
 */
export const findProductSyncNotification = (
  notifications: INotification[] = [],
  eventId?: string,
): INotification | undefined =>
  eventId
    ? notifications.find(
        (notification) => notification.type === NotificationType.PRODUCT_SYNC && notification.event_id === eventId,
      )
    : undefined;
